import React from "react";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { supabase } from "../Services/supabaseClient";
import {
  ArrowLeft,
  LayoutDashboard,
  Users,
  Wallet,
  CalendarRange,
  PlayCircle,
  Settings,
  Clock3,
  CalendarCheck2,
  ShieldCheck,
  BadgeCheck,
  CreditCard,
  BarChart3,
  GitCompareArrows,
  TriangleAlert,
  Layers3,
  ChevronRight,
  ChevronLeft,
} from "lucide-react";
import logo from "../components/Images/KostPadi-Icon.png";

export default function PayrollSidebar({ setIsLoggedIn }) {
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut({ scope: "global" });

      localStorage.clear();
      sessionStorage.clear();

      window.location.replace("/login");
    } catch (error) {
      console.error("Logout error:", error);
      window.location.replace("/login");
    }
  };

  const links = [
    {
      to: "/payroll/dashboard",
      label: "Dashboard",
      icon: <LayoutDashboard size={18} />,
    },

    {
      to: "/payroll/employees",
      label: "Employees",
      icon: <Users size={18} />,
    },
    {
      to: "/payroll/structures",
      label: "Structure",
      icon: <Layers3 size={18} />,
    },
    {
      to: "/payroll/components",
      label: "Pay Components",
      icon: <Wallet size={18} />,
    },
    {
      to: "/payroll/attendance",
      label: "Attendance",
      icon: <Clock3 size={18} />,
    },
    {
      to: "/payroll/leave",
      label: "Leave Management",
      icon: <CalendarCheck2 size={18} />,
    },
    {
      to: "/payroll/benefits",
      label: "Benefits & Loans",
      icon: <CreditCard size={18} />,
    },
    {
      to: "/payroll/calendars",
      label: "Calendars",
      icon: <CalendarRange size={18} />,
    },
    {
      to: "/payroll/compliance",
      label: "Compliance",
      icon: <ShieldCheck size={18} />,
    },
    {
      to: "/payroll/runs",
      label: "Payroll Runs",
      icon: <PlayCircle size={18} />,
    },
    {
      to: "/payroll/approvals",
      label: "Approvals",
      icon: <BadgeCheck size={18} />,
    },
    {
      to: "/payroll/payments",
      label: "Payments",
      icon: <CreditCard size={18} />,
    },
    {
      to: "/payroll/reports",
      label: "Reports",
      icon: <BarChart3 size={18} />,
    },
    {
      to: "/payroll/scenarios",
      label: "Scenarios",
      icon: <GitCompareArrows size={18} />,
    },
    {
      to: "/payroll/anomalies",
      label: "Anomalies",
      icon: <TriangleAlert size={18} />,
    },
    {
      to: "/payroll/settings",
      label: "Settings",
      icon: <Settings size={18} />,
    },
  ];

  return (
    <aside className="payroll-sidebar">
      <div className="payroll-brand">
        <img src={logo} alt="Logo" className="logo" />
        <div>
          <h2>Payroll</h2>
          <p>KostPadi Payroll Suite</p>
        </div>
      </div>

      <button
        className="payroll-back-btn"
        type="button"
        onClick={() => navigate("/dashboard")}
      >
        <ArrowLeft size={16} />
        Back to KostPadi
      </button>

      <nav className="payroll-nav">
        {links.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `payroll-nav-link ${isActive ? "active" : ""}`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
      {/* Footer */}
      <div className="sidebar-footer">
        <button
          className="logout-btn"
          onClick={handleLogout}
          data-tip={collapsed ? "Logout" : undefined}
        >
          {!collapsed ? <span className="label">Logout</span> : "🔒"}
        </button>

        {/* Collapse handle */}
        <button
          className="collapse-btn"
          onClick={() => setCollapsed((c) => !c)}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>
    </aside>
  );
}
